import { render, staticRenderFns } from "./DeliverOrder.vue?vue&type=template&id=36dae6df&scoped=true"
import script from "./DeliverOrder.vue?vue&type=script&lang=js"
export * from "./DeliverOrder.vue?vue&type=script&lang=js"
import style0 from "./DeliverOrder.vue?vue&type=style&index=0&id=36dae6df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dae6df",
  null
  
)

export default component.exports